import _ from "lodash";

export const getCaptchaSitekey = (currentWebsite: any) => {
  return _.get(currentWebsite, "recaptcha.sitekey", "");
};
